<template>
  <div id="app">
    <transition name="fade">
      <nav_header ref="navHeader" v-if="header_class"/>
    </transition>

    <router-view/>
    <foot_container/>
  </div>
</template>

<script>
import nav_header from "@/components/nav/nav_components";
import foot_container from "@/components/foot/foot";
import axios from "axios";
import {getToken} from "./util/auth";
import {USER_INFO} from "./api/api";
import {WOW} from "wowjs";
export default {
  name: 'App',
  components:{ nav_header, foot_container },
  data(){
    return{
      header_class:true,
      scrollTimer:null
    }
  },
  created() {

    let that = this

    window.onscroll = function (params){
      that.headerStatus();
    }
    this.$store.dispatch("app/getUserInfo")
  },
  mounted() {
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true
    })

    wow.init();


    document.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.onScroll)
  },
  updated() {

    this.headerStatus()
    let that = this
    setTimeout(function () {

      that.$refs['navHeader'].navListStatus = false
      that.$refs['navHeader'].navListStatus2 = false
    },700)
  },
  methods:{

    onScroll(){

      var isTop = document.body.offsetTop === 0;
      let that = this

      clearTimeout(this.scrollTimer);
      if(isTop){
        this.header_class = false;
      }


      this.scrollTimer = setTimeout(function() {
        that.header_class = true;
      }, 300);

    },


    headerStatus(){
      let that = this;
      var scrolltopTemp=document.documentElement.scrollTop||document.body.scrollTop
      setTimeout(function () {
        let dom = that.$refs['navHeader'].navListStatus
        let dom2 = that.$refs['navHeader'].navListStatus2

        if (scrolltopTemp > 355) {
          that.$refs['navHeader'].menuChild = true
          that.$refs['navHeader'].header_color = "rgba(0,0,0,0.5)";
        } else {
          if (dom){
            that.$refs['navHeader'].menuChild = true
            that.$refs['navHeader'].header_color = "rgba(0,0,0,0.5)";
            return
          }
          if (dom2){
            that.$refs['navHeader'].menuChild = true
            that.$refs['navHeader'].header_color = "rgba(0,0,0,0.5)";
            return
          }     
          that.$refs['navHeader'].menuChild = false
          that.$refs['navHeader'].header_color = "rgba(0,0,0,0)";
        }
      }, 700)

    }
  }


}
</script>

<style>
#app {
  /*font-family: "UDデジタル教科書体NP-R";*/
  font-family: 'np_r';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
  #container{
    width: 97%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0 auto;
  }

  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
    /* .fade-leave-active for below version 2.1.8 */ {
    transform: translateY(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue